class CartDrawer extends HTMLElement {
 // ---- SCROLL LOCK HELPERS ----
 lockScroll() {
   // Save current scroll position
   this._scrollTop =
     window.pageYOffset ||
     document.documentElement.scrollTop ||
     document.body.scrollTop ||
     0;


   // Lock page scroll
   document.documentElement.style.overflow = 'hidden';
   document.body.style.overflow = 'hidden';
 }


 unlockScroll() {
   // Unlock page scroll
   document.documentElement.style.overflow = '';
   document.body.style.overflow = '';


   // Restore scroll position
   if (typeof this._scrollTop === 'number') {
     window.scrollTo(0, this._scrollTop);
   }
 }


 constructor() {
   super();


   this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
   this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
   this.setHeaderCartIconAccessibility();
 }


 setHeaderCartIconAccessibility() {
   const cartLink = document.querySelector('#cart-icon-bubble');
   if (!cartLink) return;


   cartLink.setAttribute('role', 'button');
   cartLink.setAttribute('aria-haspopup', 'dialog');


   cartLink.addEventListener('click', (event) => {
     event.preventDefault();
     this.open(cartLink);
   });


   cartLink.addEventListener('keydown', (event) => {
     if (event.code.toUpperCase() === 'SPACE') {
       event.preventDefault();
       this.open(cartLink);
     }
   });
 }


 open(triggeredBy) {
   if (triggeredBy) this.setActiveElement(triggeredBy);
   const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
   if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) {
     this.setSummaryAccessibility(cartDrawerNote);
   }


   // Activate drawer and size items area
   setTimeout(() => {
     this.classList.add('animate', 'active');


     const cartDrawerItems = this.querySelector('cart-drawer-items');
     if (cartDrawerItems) {
       cartDrawerItems.updateCartUpsellToggleState?.();
       cartDrawerItems.updateCartUpsellVisibility?.();
     }


     this.adjustItemsHeight();
   }, 10);


   if (!this.__resizeBound) {
     this.__resizeBound = true;
     window.addEventListener('resize', () => this.adjustItemsHeight());
   }


   this.addEventListener(
     'transitionend',
     () => {
       const containerToTrapFocusOn = this.classList.contains('is-empty')
         ? this.querySelector('.drawer__inner-empty')
         : document.getElementById('CartDrawer');
       const focusElement =
         this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
       trapFocus(containerToTrapFocusOn, focusElement);
     },
     { once: true }
   );


   // 🔒 Lock page scroll
   this.lockScroll();
 }


 close() {
   this.classList.remove('active');
   removeTrapFocus(this.activeElement);


   // 🔓 Unlock page scroll
   this.unlockScroll();
 }


 setSummaryAccessibility(cartDrawerNote) {
   cartDrawerNote.setAttribute('role', 'button');
   cartDrawerNote.setAttribute('aria-expanded', 'false');


   if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
     cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
   }


   cartDrawerNote.addEventListener('click', (event) => {
     event.currentTarget.setAttribute(
       'aria-expanded',
       !event.currentTarget.closest('details').hasAttribute('open')
     );
   });


   cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
 }


    // Make the items area fit exactly between announcement + header + footer
  // inside a drawer that is locked to the viewport height.
  adjustItemsHeight() {
    const inner = this.querySelector('.drawer__inner');
    if (!inner) return;

    const itemsContainer = inner.querySelector('#CartDrawer-CartItems');
    const footer = inner.querySelector('.drawer__footer');
    const header = inner.querySelector('.drawer__header');
    const announcement = inner.querySelector('.cart-drawer__announcement');

    if (!itemsContainer || !footer || !header) return;

    // 1) Lock the inner panel to viewport height so it never exceeds the screen
    const viewportH = window.innerHeight || document.documentElement.clientHeight;
    inner.style.height = viewportH + 'px';
    inner.style.maxHeight = viewportH + 'px';

    // 2) Measure elements inside the drawer
    const headerH = header.getBoundingClientRect().height;
    const footerH = footer.getBoundingClientRect().height;
    const announcementH = announcement
      ? announcement.getBoundingClientRect().height
      : 0;

    // Small safety buffer so nothing touches the edges
    const buffer = 4;

    // 3) Available space for the items area *inside* the fixed-height inner panel
    const available = inner.clientHeight - headerH - footerH - announcementH - buffer;

    const MIN_HEIGHT = 140;
    const max = isNaN(available) || available < MIN_HEIGHT
      ? Math.max(MIN_HEIGHT, viewportH - 200)
      : available;

    // 4) Apply scroll only to the items container
    itemsContainer.style.maxHeight = max + 'px';
    itemsContainer.style.overflowY = 'auto';
    itemsContainer.style.webkitOverflowScrolling = 'touch';
  }



 renderContents(parsedState) {
  // 🔁 Mark the drawer as empty / not empty on the ROOT element
  // (CSS for the empty state relies on .cart-drawer.is-empty)
  this.classList.toggle('is-empty', parsedState.item_count === 0);

  this.productId = parsedState.id;

  // Update the HTML for each section we care about
  this.getSectionsToRender().forEach((section) => {
    const sectionElement = section.selector
      ? document.querySelector(section.selector)
      : document.getElementById(section.id);

    if (!sectionElement) return;

    sectionElement.innerHTML = this.getSectionInnerHTML(
      parsedState.sections[section.id],
      section.selector
    );
  });

  // Recalculate items area height when there ARE items
  this.adjustItemsHeight && this.adjustItemsHeight();

  setTimeout(() => {
    const overlay = this.querySelector('#CartDrawer-Overlay');
    if (overlay) {
      overlay.addEventListener('click', this.close.bind(this));
    }
    this.open();
  });
}



 getSectionInnerHTML(html, selector = '.shopify-section') {
   return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
 }


 getSectionsToRender() {
   return [
     {
       id: 'cart-drawer',
       selector: '#CartDrawer',
     },
     {
       id: 'cart-icon-bubble',
     },
   ];
 }


 getSectionDOM(html, selector = '.shopify-section') {
   return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
 }


 setActiveElement(element) {
   this.activeElement = element;
 }
}


customElements.define('cart-drawer', CartDrawer);





